


























import Vue from "vue";
import Component from "vue-class-component";
import AppHeading from "@/components/AppHeading.vue";
import { BButton, BSpinner, BJumbotron } from "bootstrap-vue";
import { namespaceInvitation, InvitationActionTypes } from "@/store/invitation";
import { InvitationAcception } from "@/models";
import { ILS_SITE_NAME } from "@/constants";
import { mapGetters } from "vuex";
import { namespaceAuth } from "../store/auth";

@Component({
  name: "AcceptInvitationPage",
  data() {
    return {
      isAccepting: false,
      ILS_SITE_NAME: ILS_SITE_NAME
    };
  },
  computed: {
    ...mapGetters(namespaceAuth, {
      isLoggedIn: "isLoggedIn"
    })
  },
  components: { AppHeading, BButton, BSpinner, BJumbotron }
})
export default class AcceptInvitationPage extends Vue {
  isLoggedIn!: boolean;
  isAccepting!: boolean;

  async onAcceptInvitation() {
    this.isAccepting = true;

    const invitationAcception: InvitationAcception = {
      confirmation_code: this.$route.params["confirmation_code"],
      confirm: true
    };
    await this.$store.dispatch(`${namespaceInvitation}/${InvitationActionTypes.AcceptInvitation}`, invitationAcception);

    this.isAccepting = false;
    const path = this.isLoggedIn ? "/" : "/auth/register";

    if (this.$route.path !== path) {
      this.$router.push(path);
    }
  }

  mounted() {
    document.body.style.overflow = "hidden";
  }

  beforeDestroy() {
    document.body.style.overflow = "auto";
  }
}
